import { render } from "./layout-block.vue?vue&type=template&id=18905575&scoped=true"
import script from "./layout-block.vue?vue&type=script&lang=ts"
export * from "./layout-block.vue?vue&type=script&lang=ts"

import "./layout-block.vue?vue&type=style&index=0&id=18905575&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-18905575"

export default script